
import React from 'react'
import Paper from 'material-ui/Paper';
import ManageSmartLockCards from '../../../../components/smartLockCards/ManageSmartLockCards';

import { smartlockcards as ROLES_CONFIG } from '../../../../config/roles';

export default class SmartLockCards extends React.Component {

  constructor(props) {
    super(props);
    //console.log(ROLES_CONFIG,this.props.authenticated.role);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null
    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.smartlockcards.indexOf(this.state.role) != -1 ?
              <Paper className="col-sm-11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3} style={{ overflowX: "visible" }}>
                <ManageSmartLockCards />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./routes/app/routes/smart-lock-cards/SmartLockCards.js